<template>
  <div class="card">
    <!-- 头部：国旗+姓名在左，星级在右 -->
    <div class="card-header">
      <div class="user-info">
        <span class="flag">{{ testimonial.flag }}</span>
        <h3 class="name">{{ testimonial.name }}</h3>
      </div>
      <div class="rating">★★★★★</div>
    </div>

    <!-- 国籍 -->
    <div class="country">{{ testimonial.country }}</div>

    <!-- 正文内容 (弹性占用剩余空间) -->
    <p class="content">{{ testimonial.content }}</p>

    <!-- 底部：验证与日期 (始终贴底) -->
    <div class="card-footer">
      <span class="verified">/ Verified Client</span>
      <span class="date">{{ testimonial.date }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    testimonial: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.card {
  background: #0d1117;
  border: 1px solid #1f2937;
  border-radius: 8px;
  padding: 20px;

  /* 保证卡片高度一致的核心 Flex 布局 */
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
  /* 撑满 Grid 单元格的高度 */

  /* 悬停弹动效果核心 CSS */
  transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1),
    border-color 0.3s ease,
    box-shadow 0.3s ease;
}

/* 悬停时：上浮弹动，边框变绿 */
.card:hover {
  transform: translateY(-8px) scale(1.02);
  border-color: #00ff88;
  box-shadow: 0 10px 25px rgba(0, 255, 136, 0.2);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.flag {
  font-size: 1.5rem;
}

.name {
  font-size: 1.2rem;
  font-weight: bold;
  margin: 0;
  color: #fff;
}

/* 星级颜色 */
.rating {
  color: #ffd700;
  font-size: 1rem;
  letter-spacing: 2px;
}

/* 国家小字 */
.country {
  color: #00ff88;
  font-size: 0.9rem;
  margin-bottom: 15px;
}

/* 正文 */
.content {
  color: #a0b3cc;
  line-height: 1.8;
  font-size: 0.95rem;
  margin: 0 0 20px;
  flex: 1;
  /* 让内容占满剩余空间，把底部推到最下 */
}

/* 底部验证 */
.card-footer {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #1f2937;
  padding-top: 15px;
  font-size: 0.9rem;
}

.verified,
.date {
  color: #a0b3cc;
}
</style>